<template>
  <footer>
    <svg
      class="curved-shape2"
      fill="#f5f7f9"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      viewBox="0 0 1500 103.06"
      style="enable-background: new 0 0 1500 103.06"
      xml:space="preserve"
    >
      <path
        class="st0"
        d="M0,103.06h1500c0,0,0-90.59-101.4-92.01c-91.07-1.28-546.33,0.36-681.51,0.36  c-127.36,0-507.58-0.32-618.77-0.36C0,11,0,103.06,0,103.06z"
      />
    </svg>
    <div class="container">
      <div style="margin: auto" class="row">
        <div class="col-12 col-md-4">
          <h3>{{ $t("ContactUs") }}</h3>
          <a href="tel://02144631360" id="phone" dir="auto">
            <small style="display: block">
              <span style="display: inline-block">021-44631360-5 </span></small
            >
          </a>
          <a href="mailto:help@citytours.com" id="email_footer"
            >support@dariushgroup.com</a
          >
          <a>
                  <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="#fff"
              viewBox="0 0 24 24"
              width="26px"
              height="26px"
              style="margin-left:9px"
            >
              <path
                d="M 12.011719 2 C 6.5057187 2 2.0234844 6.478375 2.0214844 11.984375 C 2.0204844 13.744375 2.4814687 15.462563 3.3554688 16.976562 L 2 22 L 7.2324219 20.763672 C 8.6914219 21.559672 10.333859 21.977516 12.005859 21.978516 L 12.009766 21.978516 C 17.514766 21.978516 21.995047 17.499141 21.998047 11.994141 C 22.000047 9.3251406 20.962172 6.8157344 19.076172 4.9277344 C 17.190172 3.0407344 14.683719 2.001 12.011719 2 z M 12.009766 4 C 14.145766 4.001 16.153109 4.8337969 17.662109 6.3417969 C 19.171109 7.8517969 20.000047 9.8581875 19.998047 11.992188 C 19.996047 16.396187 16.413812 19.978516 12.007812 19.978516 C 10.674812 19.977516 9.3544062 19.642812 8.1914062 19.007812 L 7.5175781 18.640625 L 6.7734375 18.816406 L 4.8046875 19.28125 L 5.2851562 17.496094 L 5.5019531 16.695312 L 5.0878906 15.976562 C 4.3898906 14.768562 4.0204844 13.387375 4.0214844 11.984375 C 4.0234844 7.582375 7.6067656 4 12.009766 4 z M 8.4765625 7.375 C 8.3095625 7.375 8.0395469 7.4375 7.8105469 7.6875 C 7.5815469 7.9365 6.9355469 8.5395781 6.9355469 9.7675781 C 6.9355469 10.995578 7.8300781 12.182609 7.9550781 12.349609 C 8.0790781 12.515609 9.68175 15.115234 12.21875 16.115234 C 14.32675 16.946234 14.754891 16.782234 15.212891 16.740234 C 15.670891 16.699234 16.690438 16.137687 16.898438 15.554688 C 17.106437 14.971687 17.106922 14.470187 17.044922 14.367188 C 16.982922 14.263188 16.816406 14.201172 16.566406 14.076172 C 16.317406 13.951172 15.090328 13.348625 14.861328 13.265625 C 14.632328 13.182625 14.464828 13.140625 14.298828 13.390625 C 14.132828 13.640625 13.655766 14.201187 13.509766 14.367188 C 13.363766 14.534188 13.21875 14.556641 12.96875 14.431641 C 12.71875 14.305641 11.914938 14.041406 10.960938 13.191406 C 10.218937 12.530406 9.7182656 11.714844 9.5722656 11.464844 C 9.4272656 11.215844 9.5585938 11.079078 9.6835938 10.955078 C 9.7955938 10.843078 9.9316406 10.663578 10.056641 10.517578 C 10.180641 10.371578 10.223641 10.267562 10.306641 10.101562 C 10.389641 9.9355625 10.347156 9.7890625 10.285156 9.6640625 C 10.223156 9.5390625 9.737625 8.3065 9.515625 7.8125 C 9.328625 7.3975 9.131125 7.3878594 8.953125 7.3808594 C 8.808125 7.3748594 8.6425625 7.375 8.4765625 7.375 z"
              />
            </svg>
            <!-- <span>09045425792</span> -->
            <a href="https://wa.me/+989045425792" target="_blank">09045425792</a>

          </a>
          <a href="tel://02151007227" target="_blank" style="display: block; margin-top: 15px;"> تلفن دفتر لانژ  فرودگاه:  02151007227</a>
        </div>
        <div class="col-12 col-md-4">
          <h3>  {{ $t("Footer.EasyAccess") }}</h3>
          <ul>
            <li v-if="!IsUserAuthenticated">
              <a href="#sign-in-dialog" id="access_link">{{ $t("HomeHeader.UserEntry") }}</a>
            </li>
            <li v-if="!IsUserAuthenticated">
              <a href="#register-in-dialog" id="register_link">{{ $t("ContactUs") }}</a>
            </li>
            <ul v-if="IsUserAuthenticated">
              <div class="credit-text">
                {{ $t("Footer.YourCredit") }} : {{ GetSumDeposit | numFormat }}
              </div>
              <li>
                <router-link to="/profile/deposit" class="submenu-text"
                  >{{ $t("Footer.AddCredit") }}
                </router-link>
              </li>
              <li>
                <router-link to="/profile/dashboard" class="submenu-text"
                  >
                  {{ $t("Profilee") }}
                </router-link>
              </li>
              <li><a @click="SignOut()" class="submenu-text">{{ $t("Footer.SignOut") }}</a></li>
            </ul>
          </ul>
        </div>
        <div class="related-link col-12 col-md-4">
          <h3>{{ $t("Footer.Relatedlinks") }}</h3>
          <ul>
            <li>
              <a href="http://dariushgrandhotel.com/#!/main" target="_blank"
                > {{ $t("HomeBody.DariushGrandhotel") }}</a
              >
            </li>
            <li>
              <a href="https://dp.dariushgroup.com/" target="_blank">
                {{ $t("HomeBody.DolphinariumAndBirdsGarden") }} </a
              >
            </li>
            
            <li>
              <a target="blank" href="http://ts.dariushgroup.com">
                      {{ $t("HomeBody.FastTrackAndLounge") }} </a
                    ></li>
            
            <li>
              <a target="blank" href="http://www.zagrosairlines.com/"
                      > {{ $t("HomeBody.ZagrosAirlne") }} </a
                    ></li>
            
            <li>
              <a target="blank" href="http://www.hotelsimorgh.com/"
                      > {{ $t("HomeBody.MashhadHotelSimorgh") }} </a
                    ></li>        
            <li>
              <a href="http://blog.dariushgrandhotel.com/" target="_blank"
                > {{ $t("Footer.Blog") }} </a
              >
            </li>

            <li>
              <a
                href="http://dariushgrandhotel.com/#!/mediaGallery"
                target="_blank"
                >{{ $t("Footer.Gallery") }}</a
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="namad-div col">
        <div class="footer-organizations">
          <div class="footer-organization-item">
            <img src="../../public/img/cao_logo.png" />
            <a
              target="_blank"
              class="btn footer-organization-item"
              href="https://farasa.cao.ir/sysworkflow/fa/modern/3810212626028ab03488017019616799/6464336316028ab04e3c618028352200.php"
            >
              {{ $t("Footer.PassengerRightsSystem") }}</a
            >
          </div>
          <div class="footer-organization-item">
            <!-- <img
                id="nbqergvjfukznbqeoeukesgt"
                style="cursor: pointer"
                onclick='window.open("https://logo.samandehi.ir/Verify.aspx?id=236280&amp;p=uiwkxlaogvkauiwkmcsiobpd", "Popup","toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30")'
                alt="logo-samandehi"
                src="https://logo.samandehi.ir/logo.aspx?id=236280&amp;p=odrfqftiwlbqodrfaqgwlyma"
              /> -->
            <img
              v-if="isDotIr"
              referrerpolicy="origin"
              id="nbqergvjsizpjxlzwlaojzpe"
              style="cursor: pointer"
              onclick='window.open("https://logo.samandehi.ir/Verify.aspx?id=239147&p=uiwkxlaopfvlrfthaodsjyoe", "Popup","toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30")'
              alt="logo-samandehi"
              src="https://logo.samandehi.ir/logo.aspx?id=239147&p=odrfqftibsiynbpdshwlyndt"
            />
            <img v-else id='jxlzesgtnbqergvjapfurgvjesgt' 
            style='cursor:pointer' onclick='window.open("https://logo.samandehi.ir/Verify.aspx?id=1023530&p=rfthobpduiwkxlaodshwxlaoobpd", "Popup","toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30")' 
            alt='logo-samandehi' src='https://logo.samandehi.ir/logo.aspx?id=1023530&p=nbpdlymaodrfqftiujynqftilyma'/>
          </div>
          <div class="footer-organization-item">
            <a
              v-if="isDotIr"
              referrerpolicy="origin"
              target="_blank"
              href="https://trustseal.enamad.ir/?id=219444&amp;Code=AqUYmybdZ7zUhMgDyNtN"
              ><img
                referrerpolicy="origin"
                src="https://Trustseal.eNamad.ir/logo.aspx?id=219444&amp;Code=AqUYmybdZ7zUhMgDyNtN"
                alt=""
                style="cursor: pointer"
                id="AqUYmybdZ7zUhMgDyNtN"
            /></a>
            
          <a referrerpolicy="origin" target="_blank" href="https://trustseal.enamad.ir/?id=114248&amp;Code=X6uPI3xHKiBt5lM5moCx"><img referrerpolicy="origin" src="https://Trustseal.eNamad.ir/logo.aspx?id=114248&amp;Code=X6uPI3xHKiBt5lM5moCx" alt="" style="cursor:pointer" id="X6uPI3xHKiBt5lM5moCx"></a>

          </div>
        </div>

        <!-- <h3>هتل بزرگ داریوش کیش</h3>
          <p>
            هتل بزرگ پنج ستاره داریوش با الهام از طرح شکوهمند تخت جمشید در زمینی
            با وسعت دوازده هکتار در شمال شرق جزیره زیبای کیش نزدیک به ساحل شرقی
            در سال 1382 توسط بهترین معماران ایرانی ساخته شده است. این هتل موزه
            دارای 184 اتاق، سوییت و کاباناهای مجلل با چشم انداز دریا و باغ است.
          </p> -->
      </div>
      <div class="row">
        <div class="col-md-12">
          <div id="social_footer">
            <ul>
              <li>
                <a href="#">
                  <i class="icon-facebook"></i>
                </a>
              </li>
              <li>
                <a href="#">
                  <i class="icon-twitter"></i>
                </a>
              </li>
              <li>
                <a href="#">
                  <i class="icon-google"></i>
                </a>
              </li>
              <li>
                <a href="#">
                  <i class="icon-instagram"></i>
                </a>
              </li>
              <li>
                <a href="#">
                  <i class="icon-pinterest"></i>
                </a>
              </li>
              <li>
                <a href="#">
                  <i class="icon-vimeo"></i>
                </a>
              </li>
              <li>
                <a href="#">
                  <i class="icon-youtube-play"></i>
                </a>
              </li>
            </ul>
            <div style="display: inline-flex">
              <p> {{ $t("Footer.CopyRight") }}.</p>

              <div class="build-badge">
                <span class="build-badge__label">{{ ver }}</span
                ><span
                  class="build-badge__status build-badge__status-information"
                  >Ver</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import store from "../views/profile/store/index";
import resource from "../../public/commonResource";
export default {
  name: "PdkFooter",
  store,
  data() {
    return {
      isAuthenticated: false,
      id: "",
      ver: "",
      samandehiUrl: "",
      enamadUrl: "",
      host: "",
      isDotIr: false,
    };
  },
  computed: {
    IsUserAuthenticated() {
      return this.$store.getters.IsUserAuthenticated;
    },
    GetUserName() {
      return this.$store.getters.UserInfo.userName;
    },
    GetSumDeposit() {
      return this.$store.getters.GetSumDeposit;
    },
  },
  methods: {
    SignOut() {
      this.$store.dispatch("signOut").then(() => {
        // $.magnificPopup.close();
        this.$router.push("/");
      });
    },
    async getUserId() {
      this.id = this.$store.getters.GetUserId;
    },
    checkHost() {
      if (this.host.toLowerCase() === "dariushgroup.com") {
        this.isDotIr = false;
      } else if (this.host.toLowerCase() === "dariushgroup.ir") {
        this.isDotIr = true;
      } else {
        this.isDotIr = false;
      }
    },
  },
  created() {
    this.ver = resource.version;
    this.getUserId();
    this.host = window.location.host;
    this.checkHost();
  },
};
</script>
<style lang="css" scoped>
@media only screen and (max-width: 750px) {
  .related-link {
    display: none !important;
  }
  .namad-div {
    margin-top: 30px;
    text-align: center;
  }
}

.related-link {
  display: block;
}

.lng-icon {
  width: 30px;
  height: 20px;
}

.build-badge {
  background-color: transparent;
  display: inline-block;
  height: 27px;
  line-height: 20px;
  font-size: 12px;
  margin-right: 15px;
}

.build-badge__label,
.build-badge__status {
  display: inline-block;
  padding: 0 6px 1px 6px;
}

.build-badge__label {
     background-color: #2762a5;
    color: #fff;
    border-radius: 0 10px 10px 0;
        padding: 2px 11px;
}

.build-badge__status-information {
      background-color: #2762a5;
    color: #fff;
    border-right: 1px solid #4082cd;
    border-radius: 10px 0 0 10px;
    padding: 2px 11px;
}
.curved-shape2 {
  position: absolute;
  top: -30px;
  width: 100%;
  right: 0;
  z-index: 99;
  transform: rotate(180deg);
}
</style>